// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { iconsSharedStyles } from "@eisinc/App/SharedStyles/IconsStyles";
import { savedOrderDetailsActionButtonsStyles } from "@eisinc/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.deleteButton = {
    css: css`
            ${iconsSharedStyles}
        `,
};
savedOrderDetailsActionButtonsStyles.addToListButton = {
    css: css`
            ${iconsSharedStyles}
        `,
};
savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    css: css`
            ${iconsSharedStyles}
        `,
};
savedOrderDetailsActionButtonsStyles.printButton = {
    css: css`
            ${iconsSharedStyles}
        `,
};
savedOrderDetailsActionButtonsStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
            width: 100%;
            display: flex;
            justify-content: flex-end;
        `,
};
savedOrderDetailsActionButtonsStyles.menuHiddenContainer = {
    above: "sm",
};
savedOrderDetailsActionButtonsStyles.middleHiddenContainer = {
    above: "md",
    below: "md",
    css: css`
            width: 100%;
            display: flex;
            justify-content: flex-end;
        `,
};
savedOrderDetailsActionButtonsStyles.middleOverflowMenu = {
    cssOverrides: {
        wrapper: css`
                width: 100%;
                max-width: 30px;
            `,
    },
    buttonProps: {
        variant: "secondary",
        css: css`
                max-width: 100%;
            `,
    },
};
savedOrderDetailsActionButtonsStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
                width: 100%;
                max-width: 30px;
            `,
    },
    buttonProps: {
        variant: "secondary",
        css: css`
                max-width: 100%;
            `,
    },
};
savedOrderDetailsActionButtonsStyles.twoButtonModalStyles = {
    cancelButton: {
        variant: "secondary",
    },
    submitButton: { variant: "tertiary" },
};
savedOrderDetailsActionButtonsStyles.buttonWrapper = {
    css: css`
            margin-left: 20px;
            display: flex;
        `,
};
savedOrderDetailsActionButtonsStyles.iconStyle = {
    size: 16,
    css: css`
            color: ${getColor("primary.main")} !important;
            margin-right: 5px;
        `,
};
